// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"a66b2026","120":"52f693fd","132":"e0a8be6f","205":"011c2603","239":"9f9aa2c5","319":"601c471c","412":"45a70ee8","429":"a83e0d59","508":"73204344","551":"a0a1b83d","732":"4f09486f","776":"3205b05e","796":"53aaeeb7","815":"91a39f9d","977":"26a6c3a3"}[chunkId] + ".chunk.js";
};